export interface NurseryLocation {
  id: string;
  locationId: number;
  name?: string;
  normalizedName?: string;
  code?: string;
  propertyName?: string;
  locationTypeId: number;
  locationTypeName?: string;
  costCenterId: number;
  costCenter?: string;
  regionId: number;
  regionName?: string;
  zoneId: number;
  zoneName?: string;
  vendorId: number;
  vendorName?: string;
  isSapGenericDeposit: boolean;
  isActive: boolean;
  propertyId: number;
  isInitialOrigin: boolean;
  longitude: number;
  latitude: number;
}

export class NurseryLocationProperties {
  static readonly vendorId = 'vendorId';
  static readonly normalizedName = 'normalizedName';
}
